import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus, setLoader } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import { AlertBar, AlertConfirm } from '../../Modals/AlertBar';
import DateTimeRange from '../UserControl/DateTimeRange/DateTimeRange';
import moment from 'moment';
import ReactToExcel from 'react-html-table-to-excel';
import MapAlertSummaryReport from '../../components/Report/MapAlertSummaryReport';
import { TimePicker } from 'antd';

let deviceNo = '';

class ReportStop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectHistoryDateRange:{
                startTimeHistory:"00:00",
                endTimeHistory:"23:50"
            },
            selectDateRange: {
                startDate: null,
                endDate: null
            },
            carId: [],
            carGroupList: [],
            reportEventAlertList: [],
            isClickRowToShowLocation: false,

            isClickLoadReport: '',
            reportType: '',
            selectedReportType: '',
            totalPage: 0,
            reportList: [],
            reportSummaryList: {},
            deviceGroupList: [],

            selectedGroup: '',
            startDate: moment().format('DD-MM-YYYY'),
            endDate: moment().format('DD-MM-YYYY'),
            is_speed_over: false,
            speed_over_interval: 0,

            criteriaSearch: {
                device_group: '',
                start_date : moment().format('DD-MM-YYYY'),
                end_date: moment().format('DD-MM-YYYY'),
                is_speed_over: false,
                speed_over_interval: 0,
                stop_interval: 10
            },

            speedOverSummaryList: [],
            showModalReport: false,
            device_no: '',
            symbolId: '',
            symbolColor: '',
            lat: 0,
            long: 0,
            isFullScreen: false,
            isDownLoadExcel: false,
            stopInterval: 10,
            isDownLoadPdf: false,
            placeName: '',
            reportStopSummary: [],
            reportStopList: [],

            resultForReport: [],
            gReportId: {
                SUMMARY: "01",
                GROUP_SUMMARY: "02",
                WORKLOAD: "03",
                ALERT: "04",
                ROUTE: "05",
                LENGTH: "06",
                PARKING: "07",
                POI: "08",
                AREA: "09",
                RFID: "10"
            },
            stopMachineOn: false,
            isMobile: false
        }
    }

    componentWillMount() {
        this.setState({ isMobile: window.innerWidth < 400 });
    }

    componentDidMount() {
        this.getDeviceAndGroupList();
        // this.getReportRoute();
    }

    componentWillUnmount(){
        this.setState({isDownLoadPdf: false});
    }

    getReportStop = (objCriteriaSearch) => {
        const { token } = this.props;
        const { startDate, endDate, selectHistoryDateRange, stopMachineOn } = this.state;

        const pageNo = 1;
        const pageSize = 50;
        const reqBody = typeof objCriteriaSearch !== 'undefined' ? objCriteriaSearch : [{}];
        setLoader(true);
        fetch(`http://203.150.199.244/api/report/getReportStop/${pageNo}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "devices": reqBody,
                "start_date": `${startDate} ${selectHistoryDateRange.startTimeHistory}`,
                "end_date": `${endDate} ${selectHistoryDateRange.endTimeHistory}`,
                "stop_machine_on": stopMachineOn
                })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                if (data.RESULT_STATUS === "000") {
                data.RESULT_DATA[0].details.map(obj => {
                    objList.push({
                        date: obj.date,
                        device_id: obj.device_id,
                        device_no: obj.device_no,
                        driver_name: obj.driver_name,
                        driver_no: obj.driver_no,
                        is_driver_by_rfid: obj.is_driver_by_rfid,
                        status: obj.status,
                        elapse: obj.elapse,
                        end_at_latitude: obj.end_at_latitude,
                        end_at_longitude: obj.end_at_longitude,
                        end_at_place: obj.end_at_place,
                        end_time: obj.end_time,
                        event_code: obj.event_code,
                        start_at_latitude: obj.start_at_latitude,
                        start_at_longitude: obj.start_at_longitude,
                        start_at_place: obj.start_at_place,
                        start_time: obj.start_time
                    })
                });
                this.setState({
                    reportStopList: objList,
                    reportStopSummary: data.RESULT_DATA[0].summary,
                    resultForReport: data.RESULT_DATA[0]
                });
            } else {
                    this.setState({
                        reportStopList: [],
                        reportStopSummary: [],
                        resultForReport: []
                    });
                }
            })
            .then(() => {
                setLoader(false);
            })
    }

    getDeviceAndGroupList = () => {
        const { token } = this.props;
        setLoader(true);
        fetch(`http://203.150.199.244/api/admin/getDeviceAndGroupList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                let objList2 = [];
                data.RESULT_DATA.map((data, key) => {
                        objList.push(data.name);
                        objList2.push(data);
                 })
                this.setState({
                    carId: objList,
                    carGroupList: objList2
                });
                setLoader(false);
            })
            .catch(function (err) {
                console.log('err:', err);
                setLoader(false);
                // POST failed...
            });
    }



    setRangeDate(sDate, eDate) {
        let startDate = sDate;
        let endDate = eDate;
        if(sDate && eDate && sDate !== null && eDate !== null){
            startDate = sDate.toObject();
            endDate = eDate.toObject();
            this.setState({
                startDate: moment(startDate).format('DD-MM-YYYY'),
                endDate: moment(endDate).format('DD-MM-YYYY')
            })
        }
    }

    handleClick = () => {
        const { isClickLoadReport } = this.state;
        if (isClickLoadReport === 'show') {
            this.setState({isClickLoadReport: ''});
        } else {
            this.setState({isClickLoadReport: 'show'});
        }
    }

    handleSubmitSearchReport = () => {
        const {
            selectedGroup,
            carGroupList
        } = this.state;

        let objCriteriaSearch = []
        if (selectedGroup.label) {
            carGroupList.map(data => {
                if (data.name === selectedGroup.label) {
                    objCriteriaSearch.push(data);
                }
            });
        }
        this.getReportStop(objCriteriaSearch);
    }

    handleFullScreenToggle = () => {
        const { isFullScreen } = this.state;
        if (!isFullScreen) {
            this.setState({isFullScreen: true});
        } else {
            this.setState({isFullScreen: false});
        }
    }

    handleStartTimeHistoryChange(value){
        if (value) {
            this.state.selectHistoryDateRange.startTimeHistory = value.format('HH') + ":" + value.format('mm');
        }
    }
    handleEndTimeHistoryChange(value){
        if (value) {
            this.state.selectHistoryDateRange.endTimeHistory = value.format('HH') + ":" + value.format('mm');
        }
    }

    getReportPDF = () => {
        let date = `ระหว่างวันที่ ${this.state.startDate} ถึง ${this.state.endDate}`;
        const { token} = this.props;
        const { resultForReport, gReportId } = this.state;
        const reportId = gReportId.PARKING;
        fetch(`http://203.150.199.244/api/report/exportPdf/${reportId}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token

            },
            body: JSON.stringify({
                "title":date,
                "result_data": resultForReport
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`;
                // setTimeout(function(){ document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`; }, 1000);
            })
    }

    summaryGroup = (sums) => {
        if (deviceNo !== sums) {
            deviceNo = sums;
            return true
        } else {
            return false
        }
    }

    render(){
        const { onClickBackToReportPortal, t } = this.props;
        const {
            carId,
            isClickLoadReport,
            selectedGroup,
            startDate,
            endDate,
            device_no,
            symbolId,
            symbolColor,
            isFullScreen,
            isDownLoadPdf,
            isClickRowToShowLocation,
            reportStopList,
            placeName,
            reportStopSummary,
            isMobile
        } = this.state;
        // let dataLoop;
        // const dataList = map(carId, (dataEach, key) => {
        //     dataLoop = {
        //         value: key,
        //         label: dataEach
        //     };
        //     return dataLoop;
        // });
        let dataList = [{value:"",label:"-- ทั้งหมด --"}]
        carId.map((dataEach, key) =>{
            dataList.push({value: key,label: dataEach})
        })
        const stylePdf = isDownLoadPdf ? '800px' : '100%';
        return(
            <div className="gray-panel" >
                <div className="col-md-8">
                    <h5 style={{ paddingLeft: '2em',cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                        <i
                            className="fa fa-arrow-left"
                            aria-hidden="true"
                            style={{ color: 'rgb(115, 134, 213)'}} />
                            <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft:10,marginRight:5,cursor:"pointer" }} />{t('รายงานข้อมูล')}
                    </h5>
                </div>
                <div className="row">
                    <div className="col-md-4 row">


                    </div>
                </div>
                <div className="col-md-1">
                </div>
                <hr/>
                <div className=" mx-auto">
                    <div >
                        <div className="layout-container">
                            <div className="layout-content">
                                <h5 className="no-margin">
                                  <span className="fa-stack fa-lg" style={{color: 'orange'}}>
                                    <i className="fa fa-circle fa-stack-2x" />
                                    <i className="fa fa-file-text-o fa-stack-1x" style={{color: 'white'}} />
                                  </span>
                                    {t('รายงานการจอดรถ')}
                                </h5>

                                <form name="searchfrom" className="form-inline">
                                 <div className="row">
                                    <div className='form-group'>
                                        <label>{t('ทะเบียนรถ')}</label>&nbsp;
                                        <div style={{width: '180px', fontSize: '13px'}}>
                                            <Select
                                                value={selectedGroup}
                                                onChange={(data) => this.setState({ selectedGroup: data })}
                                                options={dataList}
                                                placeholder={`-- ${t('ทั้งหมด')} --`}
                                            />
                                        </div>
                                    </div>
                                    &nbsp;
                                    {isMobile && <div className="col-md-12">{'\n'}</div>} 
                                     <label htmlFor="example-text-input" >{t('ระหว่างวันที่')}</label>&nbsp;
                                     {isMobile && <div className="col-md-12">{'\n'}</div>} 
                                     <TimePicker allowEmpty={false} className="timeHistory" onChange={this.handleStartTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />&nbsp;
                                     <div className='row' >
                                            <div className="input-group date" id="datetimepicker1">
                                                <DateTimeRange
                                                    small
                                                    startDateId="MyDatePicker"
                                                    endDateId="your_unique_end_date_id"
                                                    isBack
                                                    onSelectDate={this.setRangeDate.bind(this)}/>
                                            </div>
                                    </div>&nbsp;
                                     <TimePicker className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />&nbsp;
                                     &nbsp;&nbsp;

                                     {isMobile && <div className="col-md-12">{'\n'}</div>} 
                                     {/* <div className={isMobile ? 'col-md-4' : ''}>
                                         <input
                                             type="checkbox"
                                             defaultChecked={false}
                                             onClick={(e) => this.setState({ stopMachineOn: e.target.checked })} />
                                         &nbsp;
                                         {t('จอดรถดับเครื่อง')}
                                     </div> */}
                                     <label >
                                            <label className="col-form-label " style={{ cursor: "pointer" }}>
                                            <input
                                             type="checkbox"
                                             defaultChecked={false}
                                             onClick={(e) => this.setState({ stopMachineOn: e.target.checked })} />
                                         &nbsp;
                                         {t('จอดรถดับเครื่อง')}
                                            </label>

                                        </label>
                                     &nbsp;&nbsp;
                                     {isMobile && <div className="col-md-12">{'\n'}</div>}
                                     <div className="btn-group">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-report"
                                            onClick={() => this.handleSubmitSearchReport()}
                                            data-ext="html">
                                            {t('ตกลง')}
                                        </button>
                                        <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                                            <span className="caret" />
                                        </button>
                                            <ul className={`dropdown-menu ${isClickLoadReport}`}>
                                                <li onClick={() => this.setState({isClickLoadReport: '', reportType: 'pdf'}, () => this.getReportPDF())} className="item-text">
                                                    <i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue', marginRight: '11px'}}/>
                                                    {t('รายงานแบบ PDF')}
                                                </li>

                                                <li
                                                    style={{ width: '220px' }}
                                                    onClick={() => this.setState({isClickLoadReport: '' , reportType: 'excel', isDownLoadExcel: true})}
                                                    className="item-text">
                                                        <i className="fa fa-fw fa-file-excel-o" style={{color: 'green', marginRight: (isMobile ? '11px' : '' )}}/>
                                                        <ReactToExcel
                                                            className={isMobile ? '' : 'btn'}
                                                            // className="btn-light"
                                                            table="table-to-excel"
                                                            filename="excelFile"
                                                            sheet="sheet 1"
                                                            buttonText={t('รายงานแบบ Excel')}/>
                                                </li>
                                            </ul>
                                    </div>
                                 </div>
                                </form>
                                <div className="row">
                                    <div className="clearfix" />
                                </div>
                                <hr />

                                <div ref={el => (this.printableTable = el)}>
                                    <table id='table-to-excel' border='1' style={{fontSize: '14px', backgroundColor: 'white' , width: isMobile ? '802px' : stylePdf}} >
                                    <div style={{display: 'none', fontSize: '18px'}}>{t('รายงานการจอดรถ')}</div>
                                    <div style={{display: 'none', fontSize: '14px'}} >{`${t('ชื่อรถ')} : ${selectedGroup.label}`}</div>
                                    <div style={{display: 'none', fontSize: '14px'}} >
                                        {`${t('วันที่')} : ${moment(startDate).format('DD/MM/YYYY')}`}
                                        {startDate !== endDate &&
                                        ` - ${moment(endDate).format('DD/MM/YYYY')}`
                                        }
                                    </div>
                                    <div style={{display: 'none', fontSize: '14px'}}>{`${t('ออกรายงาน')} : ${moment().format('DD/MM/YYYY HH:mm')}`}</div>
                                    {
                                        reportStopList.length !== 0 &&

                                        <thead style={{wordBreak: 'break-word', whiteSpace: 'pre-wrap'}}>
                                        <tr>
                                            <th width="80" className="text-center">{t('วันที่เริ่ม')}</th>
                                            <th width="80" className="text-center">{t('เวลาเข้า')}</th>
                                            <th width="80" className="text-center">{t('สิ้นสุด')}</th>
                                            <th width="70" className="text-center">{t('เวลาออก')}</th>
                                            <th width="120" className="text-center">{t('สถานที่')}</th>
                                            <th width="90" className="text-center">{t('เวลาจอด')}</th>
                                            <th width="90" className="text-center">{t('สถานะ')}</th>
                                            <th width="90" className="text-center">{t('น้ำมัน')}</th>
                                            <th width="90" className="text-center">{t('เครื่องยนต์')}</th>
                                            <th width="90" className="text-center">{t('ละติจูด')}</th>
                                            <th width="90" className="text-center">{t('ลองติจูด')}</th>
                                        </tr>
                                        </thead>
                                    }
                                    {
                                        reportStopList.map((data, key) => {
                                            return (
                                                <tbody>
                                                    { this.summaryGroup(data.device_no) &&
                                                        <tr style={{backgroundColor: '#F5F5F5'}}>
                                                            <td colSpan={12}>&nbsp;&nbsp; {'\u00A0'}{data.device_no}</td>
                                                        </tr>
                                                    }
                                                    <tr
                                                        className="namTrhover"
                                                        style={{textAlign: 'center'}}
                                                        key={key}
                                                        onClick={() =>
                                                            this.setState({
                                                                lat: data.start_at_latitude,
                                                                long: data.start_at_longitude,
                                                                device_no: data.device_no,
                                                                symbolId: data.symbol_id,
                                                                symbolColor: data.symbol_color,
                                                                isClickRowToShowLocation: true,
                                                                placeName: data.end_at_place
                                                            })}>
                                                        <td>{data.date}</td>
                                                        <td>{data.start_time}</td>
                                                        <td>{''}</td>
                                                        <td>{data.end_time}</td>
                                                        <td>{data.end_at_place}</td>
                                                        <td>{data.elapse}</td>
                                                        <td>{data.status}</td>
                                                        <td>{''}</td>
                                                        <td>{''}</td>
                                                        <td>{data.end_at_latitude}</td>
                                                        <td>{data.end_at_longitude}</td>
                                                    </tr>
                                                </tbody>

                                            )
                                        })
                                    }
                                    {/*{*/}
                                        {/*(reportStopList.length === 0) &&*/}
                                        {/*<tr>*/}
                                            {/*<td colSpan={11}>{`- -  ${t('ไม่มีข้อมูล')}  - -`}</td>*/}
                                        {/*</tr>*/}
                                    {/*}*/}
                                    {
                                        (reportStopSummary && reportStopList.length > 0) &&
                                        <tr style={{fontSize: '20px'}}>
                                            <td colSpan={5}>{t('รวม')}</td>
                                            <td>{reportStopSummary.total_elapse}</td>
                                            <td colSpan={5}>{''}</td>
                                        </tr>
                                    }
                                </table>
                                </div>
                                <iframe name='print_frame' frameBorder='0' src="about:blank" hidden={true}>{''}</iframe>
                                <div className="push-up text-center">
                                    {reportStopList.length !== 0 &&
                                        <div className="btn-group" role="group" aria-label="Basic example">
                                            <button type="button" className="btn btn-light border border-secondary"
                                                    onClick={() => this.getReportPDF()}>
                                                <i className="fa fa-fw fa-file-pdf-o"
                                                   style={{color: 'blue'}}/>{t('รายงานแบบ PDF')}
                                            </button>
                                            <button type="button" className="btn btn-light border border-secondary">
                                                <i className="fa fa-fw fa-file-excel-o" style={{color: 'green'}}/>
                                                <ReactToExcel
                                                    style={{borderStyle: ''}}
                                                    className="btn-light btn"
                                                    table="table-to-excel"
                                                    filename="excelFile"
                                                    sheet="sheet 1"
                                                    buttonText={t('รายงานแบบ Excel')}
                                                />
                                            </button>
                                        </div>
                                    }
                                </div>
                                { isClickRowToShowLocation &&
                                <div className="modal-confirm" style={{ display: 'block', position: 'fixed', top: '-70%'}} >
                                    <div className="modal-dialog modal-dialog-centered" style={{maxWidth: isFullScreen ? '100%' : '' }}>
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title custom_align" id="Heading">{placeName}</h4>
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-hidden="true"
                                                    style={{padding: '0px', margin: '0px', position: 'inherit'}}
                                                    onClick={() => this.setState({isClickRowToShowLocation: false})} >
                                                    <span className="fa fa-times" aria-hidden="true" />
                                                </button>
                                            </div>
                                            <div className="modal-body" id="carAlertRow" >
                                                <MapAlertSummaryReport
                                                    index={1}
                                                    lat={this.state.lat}
                                                    lng={this.state.long}
                                                    text={selectedGroup.label}
                                                    symbolId={symbolId}
                                                    symbolColor={symbolColor}
                                                    handleFullScreenToggle={() => this.handleFullScreenToggle()}
                                                    isFullScreen={isFullScreen}
                                                />
                                                <button className="btn btn-primary pull-right" onClick={() => this.setState({ isClickRowToShowLocation: false })}  >{t('ตกลง')}</button>
                                            </div>
                                        </div>
                                        {/* /.modal-content */}
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {/*<ModalReportSummaryByGroup />*/}
            </div>
        );
    }
}

ReportStop.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickBackToReportPortal: PropTypes.func.isRequired
}

export default ReportStop;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportStop.js